import { navigate } from "gatsby";

export function useButtonsActions() {
  function handleAttendance() {
    window.open("https://www.koin.com.br/atendimento/");
  }

  function handleNavigateToPages() {
    navigate("/lojas");
  }

  function handleNavigateToTerms() {
    navigate("/termos");
  }

  function call() {
    if (typeof window !== "undefined") window.open("tel:30032153");
  }

  function sendMail() {
    if (typeof window !== "undefined")
      window.open("mailto:boletoparcelado@koin.com.br");
  }

  function openFAQ() {
    navigate("/#faq");
  }

  function openSite() {
    if (typeof window !== "undefined") window.open("https://koin.com.br");
  }

  return {
    handleNavigateToPages,
    call,
    sendMail,
    openSite,
    handleNavigateToTerms,
    handleAttendance,
    openFAQ
  };
}
